import { Box, Typography } from '@mui/material';
import { pxToRem } from '@geneo2-web/shared-ui';
import { mockEndSessionData, TopbarData } from '../mockData';
import { SessionStatCard } from '../../SessionStatCard';
import { ProgressRing } from '../../ProgressRing.tsx';

const styles = {
  card: {},

  row: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    gap: pxToRem(28),
  },

  scoreSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
  },

  ringWrapper: {
    width: pxToRem(180),
    height: pxToRem(180),
    marginBottom: pxToRem(14),
    filter: 'drop-shadow(0 6px 16px rgba(102,126,234,0.18))',
  },

  scoreMessage: {
    fontSize: pxToRem(14),
    fontWeight: 600,
    color: '#475569',
    textAlign: 'center',
    maxWidth: pxToRem(320),
  },

  divider: {
    width: {
      xs: '80px',
      md: '1px',
    },
    height: {
      xs: '1px',
      md: pxToRem(80),
    },
    background: '#e2e8f0',
    flexShrink: 0,
  },

  statsGrid: {
    display: 'grid',
    gap: pxToRem(12),
    flex: 1,
  },
};
export const TopbarCard = ({ topbar }: { topbar: TopbarData }) => {
  return (
    <Box sx={styles.card}>
      <Box sx={styles.row}>
        {/* LEFT: SCORE */}
        <Box sx={styles.scoreSection}>
          <Box sx={styles.ringWrapper}>
            <ProgressRing
              value={topbar.score}
              total={topbar.total}
              content={topbar.content}
              diameter={180}
              color="rgb(245, 158, 11)"
            />
          </Box>

          <Typography sx={styles.scoreMessage}>{topbar.message}</Typography>
        </Box>

        {/* DIVIDER */}
        <Box sx={styles.divider} />

        {/* RIGHT: STATS */}
        <Box
          sx={{
            ...styles.statsGrid,
            gridTemplateColumns: {
              xs: `repeat(2, 1fr)`,
              md: topbar.stats.skipped ? `repeat(4, 1fr)` : `repeat(3, 1fr)`,
            },
            alignSelf: { xs: 'stretch', md: 'unset' },
          }}
        >
          <SessionStatCard
            icon="✓"
            label="Correct"
            value={topbar.stats.correct}
            type="correct"
          />
          <SessionStatCard
            icon="✗"
            label="Incorrect"
            value={topbar.stats.incorrect}
            type="incorrect"
          />
          {!!topbar.stats.skipped && (
            <SessionStatCard
              icon="⏭"
              label="Skipped"
              value={topbar.stats.skipped}
              type="skipped"
            />
          )}
          <Box
            sx={{
              gridColumn: topbar.stats.skipped
                ? 'auto'
                : {
                    xs: '1 / -1',
                    md: 'auto',
                  },
            }}
          >
            <SessionStatCard
              icon="⏱"
              label="Time"
              value={topbar.stats.time}
              type="time"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
